/**
 * @module websocket.event.handlers.baggages.baggage-list-updated
 */
import { store } from '../../../../state/store'
import { setBaggageListUpdated } from '../../../../state/websocket.slice'

export default function handleBaggageListUpdated(context) {
  const { payload: { channelId, data } = {} } = context
  if (!data || !channelId) {
    return
  }

  const isSubscribed = store
    .getState()
    ?.websocket?.subscriptions?.some((channel) => channel === channelId)

  if (isSubscribed) {
    store.dispatch(setBaggageListUpdated(data))
  }
} 